import { Container, makeStyles, useTheme } from '@material-ui/core';
import clsx from 'clsx';
import React, { ReactElement } from 'react';
import { useSelector } from 'react-redux';
import { GlobalNotification } from '../../model';
import { RootStoreModel } from '../../redux';
import { PageError, PageErrorProps } from '../errors/scopes/page/pageError';
import NotificationMessage from '../notificationMessage/notificationMessage';

import { styles } from './page.styles';

interface PageProps {
  fullWidth?: boolean | undefined;
  notification?: GlobalNotification | undefined;
  layout?: PageLayout;
  error?: PageErrorProps;
}

export enum PageLayout {
  SINGLE_COLUMN,
  MULTI_COLUMN
}

const Page: React.FC<PageProps> = ({
  fullWidth = true,
  notification,
  layout = PageLayout.SINGLE_COLUMN,
  error = null,
  ...props
}) => {
  const currentTheme = useTheme();
  const useStyles = makeStyles(styles(currentTheme));
  const classes = useStyles();

  const autoCollapse = useSelector(
    (state: RootStoreModel) => state.layout && state.layout.sideNavAutoCollapse
  );

  return (
    <PageError {...error}>
      <Container
        maxWidth={false}
        className={clsx(classes.container, {
          [classes.containerCovered]: autoCollapse
        })}
      >
        {notification && (
          <NotificationMessage
            icon={notification?.icon}
            message={notification?.message}
            onClose={notification?.onClose}
            actions={notification.actions}
          />
        )}

        {layout === PageLayout.SINGLE_COLUMN ? (
          <Container
            maxWidth={fullWidth === true ? false : undefined}
            className={clsx(classes.content)}
          >
            {props.children as ReactElement}
          </Container>
        ) : (
          <Container
            maxWidth={fullWidth === true ? false : undefined}
            className={classes.multiColumns}
            classes={{ root: 'noPadding' }}
          >
            {props.children as ReactElement}
          </Container>
        )}
      </Container>
    </PageError>
  );
};

export default Page;
